const reports = {
	title: "Reports",
	select_report: "Select Report",
	select_year: "Select Year",
	select_tenant: "Select Tenant",
	select_organisation: "Select Organisation",
	report_sms_usage: "SMS Usage",
	report_organisation_tenant: "Organisation Tenants",
	report_usage_report: "Usage report",
	report_number_completed_courses: "Number of completed courses",
	report_number_of_expertise: "Number of expertise added for students",
	students: "Students",
	users: "Users",
	active_users: "Active users",
	storage_used: "Storage used",
	count: "Count",
	year: "Year",
};
export default reports;